import {
  DynamicField,
  DynamicForm,
  FieldVariant,
  NumberFieldProps,
  SelectFieldProps,
  SelectOption,
} from '../../../../components/form-builder/form-builder.types';
import { DelaisReglementairesRepository } from '../../../../store/delais-reglementaires-state/delais-reglementaires-state.repository';
import { of } from 'rxjs';

interface getDelaisReglementairesFormObjectProps {
  store: DelaisReglementairesRepository;
  typeMarcherOptions: SelectOption[];
  modePassationOptions: SelectOption[];
  isUpdateMode?: boolean;
}

export const getDelaisReglementairesFormObject = ({
  store,
  typeMarcherOptions,
  modePassationOptions,
  isUpdateMode = false,
}: getDelaisReglementairesFormObjectProps): DynamicForm => {
  const typeMarcherField: DynamicField<SelectFieldProps> = {
    label: 'settings.delaisReglementaires.form.typeMarcher',
    variant: FieldVariant.SELECT,
    isRequired: true,
    isDisabled: of(isUpdateMode),
    error: store.getNestedObservable<string>('errors', 'typeMarcherId'),
    props: {
      placeholder: 'settings.delaisReglementaires.form.typeMarcherPlaceholder',
      options: typeMarcherOptions,
      value: store.getObservable('typeMarcherSelected'),
      onSelectChange: (value: SelectOption) => {
        store.setNested('dto', 'typeMarcherId', value.code);
        store.set('typeMarcherSelected', value);
        store.setNested('errors', 'typeMarcherId', '');
      },
    },
  };

  const modePassationField: DynamicField<SelectFieldProps> = {
    label: 'settings.delaisReglementaires.form.modePassation',
    variant: FieldVariant.SELECT,
    isRequired: true,
    isDisabled: of(isUpdateMode),
    error: store.getNestedObservable<string>('errors', 'modePassationId'),
    props: {
      placeholder: 'settings.delaisReglementaires.form.modePassationPlaceholder',
      options: modePassationOptions,
      value: store.getObservable('modePassationSelected'),
      onSelectChange: (value: SelectOption) => {
        store.setNested('dto', 'modePassationId', value.code);
        store.set('modePassationSelected', value);
        store.setNested('errors', 'modePassationId', '');
      },
    },
  };

  const delaiPublicationLancementField: DynamicField<NumberFieldProps> = {
    label: 'settings.delaisReglementaires.form.delaiPublicationLancement',
    variant: FieldVariant.NUMBER,
    isRequired: true,
    error: store.getNestedObservable<string>('errors', 'delaiPublicationLancement'),
    props: {
      placeholder: 'settings.delaisReglementaires.form.delaiPublicationLancementPlaceholder',
      value: store.getNestedObservable<number>('dto', 'delaiPublicationLancement'),
      onChange: (value: number) => {
        store.setNested('dto', 'delaiPublicationLancement', value);
        store.setNested('errors', 'delaiPublicationLancement', '');
      },
      min: 0,
    },
  };

  const delaiLancementAttributionField: DynamicField<NumberFieldProps> = {
    label: 'settings.delaisReglementaires.form.delaiLancementAttribution',
    variant: FieldVariant.NUMBER,
    isRequired: true,
    error: store.getNestedObservable<string>('errors', 'delaiLancementAttribution'),
    props: {
      placeholder: 'settings.delaisReglementaires.form.delaiLancementAttributionPlaceholder',
      value: store.getNestedObservable<number>('dto', 'delaiLancementAttribution'),
      onChange: (value: number) => {
        store.setNested('dto', 'delaiLancementAttribution', value);
        store.setNested('errors', 'delaiLancementAttribution', '');
      },
      min: 0,
    },
  };

  const delaiAttributionDemarrageField: DynamicField<NumberFieldProps> = {
    label: 'settings.delaisReglementaires.form.delaiAttributionDemarrage',
    variant: FieldVariant.NUMBER,
    isRequired: true,
    error: store.getNestedObservable<string>('errors', 'delaiAttributionDemarrage'),
    props: {
      placeholder: 'settings.delaisReglementaires.form.delaiAttributionDemarragePlaceholder',
      value: store.getNestedObservable<number>('dto', 'delaiAttributionDemarrage'),
      onChange: (value: number) => {
        store.setNested('dto', 'delaiAttributionDemarrage', value);
        store.setNested('errors', 'delaiAttributionDemarrage', '');
      },
      min: 0,
    },
  };

  return {
    title: 'settings.delaisReglementaires.form.title',
    description: 'settings.delaisReglementaires.form.description',
    isHeaderHidden: true,
    grids: [
      {
        title: '',
        isHeaderHidden: true,
        gridItems: [
          {
            fields: [typeMarcherField],
          },
          {
            fields: [modePassationField],
          },
          {
            fields: [delaiPublicationLancementField],
          },
          {
            fields: [delaiLancementAttributionField],
          },
          {
            fields: [delaiAttributionDemarrageField],
          },
        ],
      },
    ],
  };
};
